import { Stack, Typography } from "@mui/material";
import { TextBlock } from "./TextBlock";
import { DisclaimerBlock } from "./DisclaimerBlock";
import { TechBadges } from "./TechBadges";
import { ContentEnrichmentSignals } from "../../../../types";

export const EnrichmentSignalsBlock = ({
  insights,
  disclaimer,
  technologies_mentioned,
  da_data_date,
}: ContentEnrichmentSignals) => {
  const disclaimerText = disclaimer.startsWith("Disclaimer:")
    ? disclaimer.split(":").slice(1).join(":").trim()
    : disclaimer;

  return (
    <Stack gap="12px">
      {da_data_date && (
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: 400,
            fontSize: "18px",
            lineHeight: "22px",
            letterSpacing: "0.3px",
            color: "#024760",
            marginTop: "-4px",
          }}
        >
          (Data as of: {da_data_date})
        </Typography>
      )}
      <TextBlock text={insights} />
      <DisclaimerBlock text={disclaimerText} />
      {technologies_mentioned && technologies_mentioned.length > 0 && (
        <TechBadges items={technologies_mentioned} />
      )}
    </Stack>
  );
};
